<template>
  <div class="score-log-page">
    <div class="section-card">
      <el-radio-group v-model="radio" class="log-radio-group">
        <el-radio-button label="0">{{ $t('msg.Player_Records') }}</el-radio-button>
        <el-radio-button label="1">{{ $t('msg.Agent_Records') }}</el-radio-button>
      </el-radio-group>

      <el-form :model="formData" :rules="radio == 0 ? userRules : porxyRules" ref="log" class="log-form" :label-width="$i18n.locale === 'US' ? '130px' : '90px'">
        <el-form-item :label="radio == '0' ? $t('msg.Player_Account') : $t('msg.Agent_Account')" prop="sid">
          <el-input v-model="formData.sid" autocomplete="off" style="width:220px;"
            :disabled="level === 2 && radio == '1'"
            @input="radio == '0' ? formData.sid = formData.sid.replace(/[^0-9]/g, '') : null"></el-input>
        </el-form-item>
        <el-form-item :label="$t('msg.Begin_Date')">
          <div class="date-time-row">
            <el-date-picker
              v-model="formData.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptions"
              :placeholder="$t('msg.Begin_Date')"
              class="date-input"
            />
            <el-time-picker
              v-model="formData.startTime"
              value-format="HH:mm:ss"
              :editable="false"
              placeholder="00:00:00"
              class="time-input"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('msg.End_Date')">
          <div class="date-time-row">
            <el-date-picker
              v-model="formData.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptions"
              :placeholder="$t('msg.End_Date')"
              class="date-input"
            />
            <el-time-picker
              v-model="formData.endTime"
              value-format="HH:mm:ss"
              :editable="false"
              placeholder="23:59:59"
              class="time-input"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setUserScoreLog">{{ $t('msg.OK2') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="section-card result-card">
      <div class="stat-row">
        <span class="stat-item up">{{ $t('msg.Total_pay') }}：<b translate="no">{{ total_pay }}</b></span>
        <span class="stat-item down">{{ $t('msg.Total_withdraw') }}：<b translate="no">{{ total_withdraw }}</b></span>
      </div>

      <el-table :data="tableData" tooltip-effect="dark" size="small"
                stripe border
                :header-cell-style="{background:'#f5f7fa', color:'#303133', fontSize:'12px', fontWeight:'600'}"
                class="log-table"
                table-layout="auto">
        <el-table-column prop="proxy_username" :label="$t('msg.Account2')" min-width="120">
          <template slot-scope="scope">
            <el-link type="primary" @click="goAgentQuery(scope.row.proxy_username)">{{ scope.row.proxy_username }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="user_id" :label="$t('msg.User_Name3')" min-width="100">
        </el-table-column>
        <el-table-column prop="coins" :label="$t('msg.Before_Score')" min-width="110" align="right">
        </el-table-column>
        <el-table-column prop="price" :label="$t('msg.Set_score2')" min-width="100" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.type === 'pay' ? 'amount-up' : 'amount-down'">
              {{ scope.row.type === 'pay' ? '+' : '-' }}{{ scope.row.price }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="coins_after" :label="$t('msg.After_Score')" min-width="110" align="right">
        </el-table-column>
        <el-table-column prop="ip" label="IP" min-width="130">
        </el-table-column>
        <el-table-column prop="time" :label="$t('msg.Date_Time1')" min-width="160" fixed="right">
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 0"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="20"
        :current-page="page"
        @current-change="handlePageChange"
        class="log-pagination"
      />
    </div>
  </div>
</template>

<script>
import {GetUserPaylog, GetProxyUserPaylog} from "../api";

export default {
  name: "Home",
  data() {
    var _userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    return {
      level: _userInfo.level,
      subUsername: localStorage.getItem('username') || '',
      radio: '0',
      formData: {
        sid: '',
        startDate: '',
        startTime: '00:00:00',
        endDate: '',
        endTime: '23:59:59',
      },
      porxyRules: {
        sid: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              // const reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/ 带有下划线_
              const reg = /^[A-Za-z0-9]+$/
              if (!reg.test(value)) {
                callback(new Error(this.$t('msg.Username_format_hint')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
      },
      userRules: {
        sid: [
          {required: true, message: this.$t('msg.Please_enter_your_account_number'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value)) {
                callback(new Error(this.$t('msg.UserId_must_be_7_digits')))
              } else {
                callback()
              }
            },
            trigger: "blur"
          }
        ],
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1)
        }
      },
      tableData: [],
      total: 0,
      page: 1,
      total_pay: 0,
      total_withdraw: 0,
      skipCache: false,
      cache: {
        '0': { sid: '', tableData: [], total: 0, page: 1, total_pay: 0, total_withdraw: 0 },
        '1': { sid: '', tableData: [], total: 0, page: 1, total_pay: 0, total_withdraw: 0 }
      }
    }
  },
  watch: {
    radio(newVal, oldVal) {
      if (this.skipCache) return
      if (this.level === 2 && newVal === '1') {
        this.cache[oldVal] = {
          sid: this.formData.sid,
          tableData: this.tableData,
          total: this.total,
          page: this.page,
          total_pay: this.total_pay,
          total_withdraw: this.total_withdraw
        }
        this.formData.sid = this.subUsername
        this.tableData = []
        this.total = 0
        this.page = 1
        this.total_pay = 0
        this.total_withdraw = 0
        return
      }
      this.cache[oldVal] = {
        sid: this.formData.sid,
        tableData: this.tableData,
        total: this.total,
        page: this.page,
        total_pay: this.total_pay,
        total_withdraw: this.total_withdraw
      }
      var r = this.cache[newVal]
      this.formData.sid = r.sid
      this.tableData = r.tableData
      this.total = r.total
      this.page = r.page
      this.total_pay = r.total_pay
      this.total_withdraw = r.total_withdraw
    }
  },
  methods: {
    setUserScoreLog() {
      var val = true
      this.$refs['log'].validate(valid => {
        if (!valid) { val = false }
      })
      if (!this.formData.startDate || !this.formData.endDate) {
        this.$message({ message: this.$t('msg.Please_enter_the_time'), type: 'error', offset: 80 });
        val = false
      }
      if (val) {
        this.page = 1
        this.fetchLog()
      }
    },
    fetchLog() {
      if (this.radio == 0) {
        var params = {
          "user_id": this.formData.sid,
          "start_time": this.formData.startDate,
          "end_time": this.formData.endDate,
          "page": this.page
        }
        GetUserPaylog(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.tableData = this.formatTime(data.data.params.data)
            this.total = data.data.params.total || 0
            if (this.tableData.length === 0) {
              this.$alert(this.$t('msg.No_Data'), '', { confirmButtonText: this.$t('msg.OK2'), center: true, customClass: 'alert' });
            }
            this.total_withdraw = data.data.params.total_withdraw || 0
            this.total_pay = data.data.params.total_pay || 0
          } else {
            var msg = data.data.params.msg || this.$t('msg.Failed_to_obtain_data')
            this.$message({ message: msg, type: 'error', offset: 80 });
          }
        })
      } else {
        var params = {
          "search_username": this.formData.sid,
          "start_time": this.formData.startDate,
          "end_time": this.formData.endDate,
          "page": this.page
        }
        GetProxyUserPaylog(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            var proxyUsername = data.data.params.proxy_username || this.formData.sid
            var rows = (data.data.params.data || []).map(row => Object.assign({ proxy_username: proxyUsername }, row))
            this.tableData = this.formatTime(rows)
            this.total = data.data.params.total || 0
            this.total_pay = data.data.params.total_pay || 0
            this.total_withdraw = data.data.params.total_withdraw || 0
            if (this.tableData.length === 0) {
              this.$alert(this.$t('msg.No_Data'), '', { confirmButtonText: this.$t('msg.OK2'), center: true, customClass: 'alert' });
            }
          } else {
            var msg = data.data.params.msg || this.$t('msg.Failed_to_obtain_data')
            this.$message({ message: msg, type: 'error', offset: 80 });
          }
        })
      }
    },
    formatTime(tableData) {
      // for (var i = 0; i < tableData.length; i++) {
      //   let date = new Date(tableData[i].time * 1000);
      //   let Y = date.getFullYear() + '-';
      //   let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      //   let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      //   let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      //   let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      //   let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      //   tableData[i]["time"] = Y + M + D + h + m + s;
      // }
      return tableData
    },
    goAgentQuery(username) {
      this.$router.push({ name: 'userSearch', query: { sid: username, user_type: '1' } })
    },
    handlePageChange(page) {
      this.page = page
      this.fetchLog()
    },
  },
  mounted() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    this.formData.startDate = `${year}-${month}-${day}`
    this.formData.startTime = '00:00:00'
    this.formData.endDate = `${year}-${month}-${day}`
    this.formData.endTime = '23:59:59'

    var querySid = this.$route.query.sid ? String(this.$route.query.sid) : ''
    var targetRadio = '0'
    if (this.$route.query.user_type == 1) {
      targetRadio = '1'
    }

    this.skipCache = true
    this.radio = targetRadio
    this.skipCache = false

    this.$nextTick(() => {
      if (this.level === 2 && targetRadio === '1') {
        this.formData.sid = this.subUsername
      } else {
        this.formData.sid = querySid
      }
      if (this.formData.sid) {
        this.fetchLog()
      }
    })
  }
}
</script>

<style lang="less">
.score-log-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  padding: 20px 24px;
}

.result-card {
  padding: 16px 24px;
  overflow-x: auto;
}

.log-radio-group {
  margin-bottom: 18px;
}

.log-form {
  .el-form-item {
    margin-bottom: 14px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}

.date-time-row {
  display: flex;
  gap: 8px;
  align-items: center;

  .date-input {
    width: 160px !important;
  }

  .time-input {
    width: 130px !important;
  }
}

.stat-row {
  display: flex;
  gap: 24px;
  margin-bottom: 14px;

  .stat-item {
    font-size: 13px;
    color: #606266;

    b {
      font-size: 15px;
      margin-left: 4px;
    }

    &.up b { color: #67c23a; }
    &.down b { color: #f56c6c; }
  }
}

.amount-up { color: #67c23a; font-weight: 600; }
.amount-down { color: #f56c6c; font-weight: 600; }

.log-table {
  width: 100%;
  overflow-x: auto;
}

.log-pagination {
  margin-top: 16px;
  text-align: right;
}

@media screen and (max-width: 500px) {
  .alert { width: 240px; }
  .date-time-row {
    flex-wrap: wrap;
    .date-input, .time-input { width: 100% !important; }
  }
  .section-card { padding: 14px 16px; }
}
</style>



// WEBPACK FOOTER //
// src/views/SetScoreLog.vue